// @flow
import React, { Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import { Row, Col } from 'reactstrap';

import CollapseContainer from '../Review/CollapseContainer';

const getAmount = obj => (isEmpty(obj) ? 0 : Number(obj[0].amount));

const empty = guide => isEmpty(guide);

const PassengerDetailSummary = ({ porters, leaders, guides }) => (
  <Fragment>
    {empty(porters) && empty(leaders) && empty(guides) ? null : (
      <CollapseContainer
        title="Additional Services"
        openCollapse={false}
        cost={getAmount(porters) + getAmount(leaders) + getAmount(guides)}
      >
        <Row>
          <Col>
            <ul>
              <GuideType guide={porters} />
              <GuideType guide={leaders} />
              <GuideType guide={guides} />
            </ul>
          </Col>
        </Row>
      </CollapseContainer>
    )}
  </Fragment>
);

const GuideType = ({ guide }) => (
  <Fragment>
    {empty(guide)
      ? null
      : guide.map(guide => (
          <li key={guide.itemType}>
            <strong>{capitalize(guide.itemType)}</strong>{' '}
            <span className="float-right">USD {Number(guide.amount).toLocaleString()}</span>
          </li>
        ))}
  </Fragment>
);

export default PassengerDetailSummary;



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Payment/AdditionalServices.jsx